import { Injectable, ViewContainerRef } from '@angular/core';

import { SettingsEntry } from './settings-entry';

@Injectable()
export class ApiHelpEntry implements SettingsEntry {
    label: string;

    constructor() {
        this.label = 'API Reference Guide (HTML)';
    }

    activate(viewContainerRef: ViewContainerRef) {
        let url = window.location.protocol + '//' + window.location.hostname + ':' +
            window.location.port + '/api-help/BpcDdosAPI.htm';

        window.open(url, '_blank');
    }

    clean() { }

}



// WEBPACK FOOTER //
// ./src/app/headerfooter/setting-entries/api-help-entry.ts